import { StrictEqualityComparer } from "../../shared/index.js";
import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const distinct = (source, comparer = StrictEqualityComparer) => {
    const generator = async () => {
        const distinctElements = [];
        for (const item of await source.toArray()) {
            const foundItem = distinctElements.find((x) => comparer(x, item));
            if (!foundItem) {
                distinctElements.push(item);
            }
        }
        return distinctElements;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
